import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2555eae3"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2555eae3')) {
      api.createRecord('2555eae3', component.options)
    } else {
      api.reload('2555eae3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2555eae3", function () {
      api.rerender('2555eae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DistributionRegionFilter/index.vue"
export default component.exports